import RequestCommissionModel from 'src/adminPanel/entities/articleManagement/RequestCommissionModel';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

export const FETCH_ARTICLE_COMMISSION_MODEL = 'FETCH_ARTICLE_COMMISSION_MODEL';
export const REQUEST_ARTICLE_COMMISSION_MODEL = 'REQUEST_ARTICLE_COMMISSION_MODEL';
export const SUCCESS_ARTICLE_COMMISSION_MODEL = 'SUCCESS_ARTICLE_COMMISSION_MODEL';
export const FAILURE_ARTICLE_COMMISSION_MODEL = 'FAILURE_ARTICLE_COMMISSION_MODEL';

export const fetchArticleCommissionModel = (pageable?: PageableQueryParams) =>
    action(FETCH_ARTICLE_COMMISSION_MODEL, { pageable });
export const requestArticleCommissionModel = () => action(REQUEST_ARTICLE_COMMISSION_MODEL);
export const requestArticleCommissionModelSuccess = (response: any) =>
    action(SUCCESS_ARTICLE_COMMISSION_MODEL, { response });
export const requestArticleCommissionModelFailure = (error: any) => action(FAILURE_ARTICLE_COMMISSION_MODEL, { error });

export const CREATE_ARTICLE_COMMISSION_MODEL = 'CREATE_ARTICLE_COMMISSION_MODEL';
export const REQUEST_CREATE_ARTICLE_COMMISSION_MODEL = 'REQUEST_CREATE_ARTICLE_COMMISSION_MODEL';
export const SUCCESS_CREATE_ARTICLE_COMMISSION_MODEL = 'SUCCESS_CREATE_ARTICLE_COMMISSION_MODEL';
export const FAILURE_CREATE_ARTICLE_COMMISSION_MODEL = 'FAILURE_CREATE_ARTICLE_COMMISSION_MODEL';

export const fetchCreateArticleCommissionModel = (commissionModelDto: RequestCommissionModel) =>
    action(CREATE_ARTICLE_COMMISSION_MODEL, { commissionModelDto });
export const requestCreateArticleCommissionModel = () => action(REQUEST_CREATE_ARTICLE_COMMISSION_MODEL);
export const requestCreateArticleCommissionModelSuccess = (response: any) =>
    action(SUCCESS_CREATE_ARTICLE_COMMISSION_MODEL, { response });
export const requestCreateArticleCommissionModelFailure = (error: any) =>
    action(FAILURE_CREATE_ARTICLE_COMMISSION_MODEL, { error });

export const UPDATE_ARTICLE_COMMISSION_MODEL = 'UPDATE_ARTICLE_COMMISSION_MODEL';
export const REQUEST_UPDATE_ARTICLE_COMMISSION_MODEL = 'REQUEST_UPDATE_ARTICLE_COMMISSION_MODEL';
export const SUCCESS_UPDATE_ARTICLE_COMMISSION_MODEL = 'SUCCESS_UPDATE_ARTICLE_COMMISSION_MODEL';
export const FAILURE_UPDATE_ARTICLE_COMMISSION_MODEL = 'FAILURE_UPDATE_ARTICLE_COMMISSION_MODEL';

export const fetchUpdateArticleCommissionModel = (commissionModelDto: RequestCommissionModel) =>
    action(UPDATE_ARTICLE_COMMISSION_MODEL, { commissionModelDto });
export const requestUpdateArticleCommissionModel = () => action(REQUEST_UPDATE_ARTICLE_COMMISSION_MODEL);
export const requestUpdateArticleCommissionModelSuccess = (response: any) =>
    action(SUCCESS_UPDATE_ARTICLE_COMMISSION_MODEL, { response });
export const requestUpdateArticleCommissionModelFailure = (error: any) =>
    action(FAILURE_UPDATE_ARTICLE_COMMISSION_MODEL, { error });

export const DELETE_ARTICLE_COMMISSION_MODEL = 'DELETE_ARTICLE_COMMISSION_MODEL';
export const REQUEST_DELETE_ARTICLE_COMMISSION_MODEL = 'REQUEST_DELETE_ARTICLE_COMMISSION_MODEL';
export const SUCCESS_DELETE_ARTICLE_COMMISSION_MODEL = 'SUCCESS_DELETE_ARTICLE_COMMISSION_MODEL';
export const FAILURE_DELETE_ARTICLE_COMMISSION_MODEL = 'FAILURE_DELETE_ARTICLE_COMMISSION_MODEL';

export const fetchDeleteArticleCommissionModel = (commissionModelId: string) =>
    action(DELETE_ARTICLE_COMMISSION_MODEL, { commissionModelId });
export const requestDeleteArticleCommissionModel = () => action(REQUEST_DELETE_ARTICLE_COMMISSION_MODEL);
export const requestDeleteArticleCommissionModelSuccess = (response: any) =>
    action(SUCCESS_DELETE_ARTICLE_COMMISSION_MODEL, { response });
export const requestDeleteArticleCommissionModelFailure = (error: any) =>
    action(FAILURE_DELETE_ARTICLE_COMMISSION_MODEL, { error });
